export const RESET_FILTERS_TEXT = "Reset Filters";
export const APPLY_FILTERS_TEXT = "Apply Filters";
